import apiClient from './apiClient';

export interface QueryParams {
  albumFrom?: string;
  albumTo?: string;
}

export interface ResultRow {
  FJ220_01: string;    // 專輯代號
  FJ220_02: number;    // 版次
  FJ220_111: string;   // 品名前碼
  FJ220_112: string;   // 品名後碼
  FJ220_13: number;    // 預估總成本
  FJ220_14: string;    // 幣別
  FJ220_15: string;    // 版次備考
  FJ221_03: number;    // 項次
  FJ221_11: number;    // 材料類型
  mat_type_text: string; // 材料類型文字
  item_code: string;   // 品項代號
  FJ221_13: string;    // 規格代號
  FJ221_14: number;    // 預估數量
  FJ221_15: string;    // 數量單位
  FJ221_16: number;    // 預估單價
  FJ221_17: string;    // 供應商代號
  FJ221_18: number;    // 損耗率%
  FJ221_19: number;    // 含損耗預估用量
  spec_memo: string;   // 組合備考
}

export interface QueryResponse {
  data: ResultRow[];
  count: number;
  message?: string;
}

export const pwj324Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwj324/query', params);
    return res.data;
  },
};
